<template>
    <div v-if="params.urlSupport">
        <b-btn
            id="support"
            pill
            class="text-primary support"
            @click="open"
        >
            <i class="icon icon-support" />
        </b-btn>
        <b-tooltip
            target="support"
            variant="primary"
            triggers="hover"
        >
            {{ $t(`main.support.tooltip`) }}
        </b-tooltip>
    </div>
</template>

<script>
import params from '@/config/params';

export default {
    name: 'SupportButton',
    data() {
        return {
            params,
        };
    },

    methods: {
        open: function() {
            window.open(params.urlSupport, '_blank');
        },
    },
};
</script>

<style lang="scss" scoped>
.support {
    padding: 0.63rem !important;
}

::v-deep {
    .icon {
        mask-size: 61em;
        mask-position: 19.7% 85.5%;
        width: 1.26rem;
        height: 1.26rem;
        color: #3C7BE0 !important;
    }
    .btn {
        &.btn-secondary {
            &:hover,
            &:active {
                background-color: #EBEBEB !important;
                box-shadow: none !important;
            }
        }

        &,
        &.btn-secondary:focus:not(.btn-secondary:hover) {
            background-color: #F5F5F5 !important;
            border: none !important;
            box-shadow: none !important;
        }
    }
}
</style>